const { fetcher } = require('services/helpers/responseHandler')

/**
 * Sends the rows of a detected Lighthouse export to be categorized. Only the three columns the
 * mapping rules use are sent; the row numbers we keep for our own messages stay in the browser.
 */
const mapLighthouseRows = async ({ format, rows }) =>
  await fetcher.post('rateCodes/lighthouse/map', {
    format,
    rows: rows.map(row => ({
      rateCode: row.rateCode,
      description: row.description,
      mapping: row.mapping
    }))
  })

const rateCodesApi = {
  lighthouse: {
    map: mapLighthouseRows
  }
}

export default rateCodesApi
